import React from 'react'
import { useState } from 'react';
import { Container } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import mete from "../images/logos/mete&design_long_text.png"
import { gsap, Power3 } from 'gsap';
import { useRef, useEffect } from 'react';
import "./MeteNavbar.scss"
import "../fonts/eu-alonira-font/EuAloniraPersonalUse-8MqqA.ttf"
function MeteNavbar() {

    const [isMenuClicked, setMenuClicked] = useState(false);



    const handleMenuClick = () => {
        setMenuClicked(!isMenuClicked);

    };


    const menuStyles = {

        boxShadow: isMenuClicked ? '5px 5px 0px #121212' : '5px 5px 0px #121212',
        transition: 'box-shadow 0.3s ease-out'
    };


    const listStyle = {
        color: isMenuClicked ? '#F0F0F0' : '#121212',

        zIndex: 151,
        transition: 'all 0.3s ease-out'
    }
    const listCoverStyle = {
        marginTop: isMenuClicked ? '56px' : '0px',
        // marginLeft: isMenuClicked ? '-210px' : '0px',
        backgroundColor: isMenuClicked ? '#121212' : '#F0F0F0',
        boxShadow: isMenuClicked ? '5px 5px 0px 17px #121212' : 'none',
        display: isMenuClicked ? 'flex' : 'none',
        position: isMenuClicked ? 'absolute' : 'relative',
        zIndex: 150,
        transition: 'all 0.2s ease-out'
    }

    const linkStyle = {

        color: isMenuClicked ? '#F0F0F0' : '#121212',

    }

    let navy = useRef(null);

    useEffect(() => {
        //content variables
        let ctx = gsap.context(() => {
            gsap.from(navy, { duration: 1, opacity: 0, y: 140, ease: Power3.easeOut, stagger: .2 })

        })

        return () => {
            ctx.revert();





        };
    }, []);
    return (
        <Navbar expand="lg" className=" transparent" sticky="top" ref={el => navy = el} >
            <Container className="curved meteNav  " style={menuStyles}>
                <Navbar.Brand href="#home" className='meteBrand'><img src={mete} alt='brand logo' /> </Navbar.Brand>
                <div className="holdAll">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className='mete-btn' onClick={handleMenuClick} />
                    <button className='buttonGreen'><a href="#HireMe">Hire Me</a></button>

                    <Navbar.Collapse id="basic-navbar-nav" style={listCoverStyle}>
                        <Nav className="me-auto sideways" style={listStyle}>
                            <Nav.Link className='links' style={linkStyle} href="#home">Home</Nav.Link>

                            <Nav.Link className='links' href="#Portfolio" style={linkStyle} >Portfolio</Nav.Link>
                            {/* <Link to="/blog" style={{ textDecoration: 'none', color: "#121212" }} className=" links"> <span className='linksa'   style={linkStyle} >Blog</span></Link> */}
                            <Nav.Link className='links' href="#Services" style={linkStyle} >Services</Nav.Link>
                            <Nav.Link className='links' href="#AboutMe" style={linkStyle}>About Me</Nav.Link>
                            <Link to="/store" style={{ textDecoration: 'none', color: "#121212" }} className=" links"> <span className='linksa' style={linkStyle} >Shop</span></Link>

                        </Nav>
                    </Navbar.Collapse>
                </div>
            </Container>
        </Navbar>
    )
}

export default MeteNavbar
